import { loadEsModule, ComponentLibrary } from '@infinity/ca-tester/utils/web-components'

export const track = async (name: string, data: { [key: string]: string | number | boolean } = {}) => {
  const { service } = await loadEsModule(ComponentLibrary.MfeShared, 'mixpanel')

  service.track(name, data)
}
